import React, { useState, useEffect } from 'react';
import { TransitionItem } from '~helpers';
import AdsBanner from '../components/AdsBanner';
import commercePropTypes from '../prop-types/commercePropTypes';

var AdsBannerContainer = function AdsBannerContainer(_ref) {
  var endPoint = _ref.endPoint,
      orientation = _ref.orientation,
      adsImageTransformation = _ref.adsImageTransformation;

  var _useState = useState(),
      adsList = _useState[0],
      setAdsList = _useState[1];

  var _useState2 = useState(false),
      inProp = _useState2[0],
      setInProp = _useState2[1];

  useEffect(function () {
    fetch(endPoint).then(function (res) {
      return res.json();
    }).then(function (resData) {
      setAdsList(resData);
      setInProp(true);
    });
  }, [endPoint]);

  if (!adsList) {
    return null;
  }

  return /*#__PURE__*/React.createElement(TransitionItem, {
    inProp: inProp
  }, /*#__PURE__*/React.createElement(AdsBanner, {
    storeName: adsList.siteName,
    adsItems: adsList.adsItems,
    adsImageHeight: 100,
    adsImageWidth: 130,
    orientation: orientation,
    adsImageTransformation: adsImageTransformation
  }));
};

AdsBannerContainer.defaultProps = {
  orientation: 'landscape'
};
export default AdsBannerContainer;